import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

const Header: React.FC = () => {
  const { user, logout } = useAuth()
  const [showDropdown, setShowDropdown] = useState(false)

  const handleLogout = async () => {
    try {
      await logout()
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  return (
    <header className="bg-white shadow-sm h-12 sm:h-16 flex items-center relative overflow-visible">
      <div className="w-full max-w-6xl mx-auto px-4 flex items-center">
        {/* Clickable logo + title */}
        <Link
          to="/"
          className="text-base sm:text-xl font-semibold text-riddell-red truncate pr-2 hover:text-riddell-darkred transition-colors duration-200 flex items-center"
        >
          <img
            src="/insite_small.png"
            alt="Insite Logo"
            className="h-6 w-6 sm:h-8 sm:w-8 mr-2 sm:mr-3 flex-shrink-0"
          />
          <span className="hidden sm:inline">Insite Support Tools</span>
          <span className="sm:hidden">Support Tools</span>
        </Link>

        {/* NON-clickable spacer */}
        <div className="flex-1" />

        {/* User dropdown (clickable) */}
        <div className="relative">
          <button
            onClick={() => setShowDropdown(!showDropdown)}
            className="flex items-center text-xs sm:text-sm font-medium text-neutral-700 hover:text-neutral-800 focus:outline-none"
          >
            <span className="mr-1 sm:mr-2 truncate max-w-24 sm:max-w-none">
              {user?.username || 'User'}
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 sm:h-5 sm:w-5 text-neutral-400 flex-shrink-0"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>

          {showDropdown && (
            <div className="absolute right-0 mt-2 w-40 sm:w-48 bg-white rounded-md shadow-lg py-1 z-[70] ring-1 ring-black ring-opacity-5 border border-gray-200">
              <button
                onClick={handleLogout}
                className="block w-full text-left px-3 sm:px-4 py-2 text-xs sm:text-sm text-neutral-700 hover:bg-neutral-100"
              >
                Sign out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}

export default Header
